import React, { useState, useEffect } from "react";
import "../styles/WhatsAppPopup.css";

const WhatsAppPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show popup only if not already shown in this session
    if (!sessionStorage.getItem("whatsappPopupShown")) {
      setIsVisible(true);
      sessionStorage.setItem("whatsappPopupShown", "true");
    }
  }, []);

  return (
    isVisible && (
      <div className="whatsapp-popup">
        <div className="popup-content">
          <button className="close-btn" onClick={() => setIsVisible(false)}>
            &times;
          </button>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="WhatsApp"
            className="whatsapp-icon"
          />
          <p>Need help? Chat with us on WhatsApp!</p>
          <a
            href="https://wa.me/9492446913" // Replace with your WhatsApp number
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-link"
          >
            Chat Now
          </a>
        </div>
      </div>
    )
  );
};

export default WhatsAppPopup;
